import OtpSender from "@/modules/auth/verifyCode";
import useVerifyPasswordOtp from "@/services/auth/hooks/useVerifyPasswordOtp";
import { SignInPayload, UserVerifyOtpPayload } from "@/services/auth/type";
import { Grid, Loader, PinInput, Stack, Text } from "@mantine/core";
import { useForm, yupResolver } from "@mantine/form";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as Yup from "yup";

const signUpSchema = Yup.object({
  password: Yup.string()
    .required("پسورد را وارد نمایید")
    .matches(
      /^[a-zA-Z0-9!@#$%^&*()_+=-]*$/,
      "پسورد نمی‌تواند شامل حروف فارسی باشد"
    ),
});

function ForgetPasswordCheckOtp() {
  const location = useLocation();
  const { phoneNumber } = location.state;

  const { mutate, isLoading } = useVerifyPasswordOtp();

  const navigate = useNavigate();

  const form = useForm<UserVerifyOtpPayload | SignInPayload>({
    validate: yupResolver(signUpSchema),
    initialValues: {
      otpCode: "",
      username: phoneNumber,
    },
  });

  useEffect(() => {
    if ((form.values as UserVerifyOtpPayload)?.otpCode?.length === 4) {
      mutate(
        {
          otpCode: (form.values as UserVerifyOtpPayload)?.otpCode,
          username: phoneNumber,
        },
        {
          onSuccess(data) {
            navigate("/auth/resetPassword", {
              state: {
                phoneNumber,
                securityToken: data,
              },
            });
          },
        }
      );
    }
  }, [form.values, phoneNumber]);

  return (
    <Stack h={300} justify="center">
      <form>
        <Grid>
          <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
            <Stack align="center" justify="center" pos="relative">
              <Text size="sm">
                کد ارسال شده به {phoneNumber} را وارد نمایید
              </Text>
              <PinInput
                size="lg"
                inputType="tel"
                inputMode="numeric"
                placeholder=""
                disabled={isLoading}
                dir="ltr"
                {...form.getInputProps("otpCode")}
              />
              {isLoading && (
                <Stack
                  justify="center"
                  align="center"
                  pos="absolute"
                  bottom={-27}
                >
                  <Loader type="dots" size="xs" />
                </Stack>
              )}
            </Stack>
          </Grid.Col>
        </Grid>
      </form>

      <OtpSender resendType="forgetPassword" />
    </Stack>
  );
}

export default ForgetPasswordCheckOtp;
